export default interface Asset {
    id: string;
    name: string;
    type: string;
    highRes: string;
    width: number;
    height: number;
    thumbnail: string;
    duration?: number;  // Video duration in seconds
    createdAt: string;
    updatedAt: string;
}

// Type guard helpers
export const isVideoAsset = (asset: Asset): boolean => {
    // Primary: check type field if available
    if (asset.type) {
        return asset.type.startsWith('video/');
    }

    // Fallback: check URL extension for video formats
    const videoExtensions = ['.mp4', '.webm', '.mov'];
    const url = asset.highRes.toLowerCase();
    return videoExtensions.some(ext => url.includes(ext));
};

export const isImageAsset = (asset: Asset): boolean => {
    // Primary: check type field if available
    if (asset.type) {
        return asset.type.startsWith('image/');
    }

    // Fallback: check URL extension for image formats
    const imageExtensions = ['.png', '.jpg', '.jpeg', '.webp', '.gif'];
    const url = asset.highRes.toLowerCase();
    return imageExtensions.some(ext => url.includes(ext));
};
